import React, { useState, useEffect, useRef } from 'react';
import { Wrapper } from './style';
import DatePicker from "react-multi-date-picker"
import Icon from "react-multi-date-picker/components/icon";
import gregorian from 'react-date-object/calendars/gregorian';
import gregorian_en from "react-date-object/locales/gregorian_en";

// Libs
import Translation from 'libs/Translation';
import { APP_CONSTANTS } from 'constants';

const GregorianDatePicker = ({ label, val, handleChange }) => {
    let defaultDate = ['', '', ''];
    if (val) {
        defaultDate = Translation.dateWithoutTime(`${val}Z`).split('/');
    }
	const [year, setYear] = useState(defaultDate[0] || 1900);
	const [month, setMonth] = useState(APP_CONSTANTS.GREGORIAN_MONTH.find(m => m.num === defaultDate[1])?.name || 'January');
	const [monthNum, setMonthNum] = useState(defaultDate[1] || `01`);
	const [day, setDay] = useState(defaultDate[2] || `01`);
	const [date, setDate] = useState();
	const [active, setActive] = useState(false);
    const dayPickerRef = useRef();
	const monthPickerRef = useRef();
	const yearPickerRef = useRef();

	const handleChangeYear = (date) => {
		setYear(date?.year);
	}
	const handleChangeMonth = (date) => {
		setMonth(date?.month?.name);
		setMonthNum(date?.month?.number < 10 ? `0${date?.month?.number}` : date?.month?.number);
	}
	const handleChangeDay = (date) => {
		setDay(date?.day < 10 ? `0${date?.day}` : date?.day);
	}

	// Convert gregorian to UTC
	useEffect(() => {	
		const UTCTime = `${year}-${monthNum}-${day}T00:00:00.000Z`;
		setDate(UTCTime);
		handleChange(UTCTime)
	}, [year, month, day])

	return (
		<Wrapper active={active}>
			<span className='label'>
				{label}
			</span>
			<div className='birth-date'>
				<div className='column-flex'>
					<span className='label'>
						Day
					</span>	
					<div 
                        className='row-flex first-input'
                        onClick={() => active !== '1' && dayPickerRef.current.openCalendar()}
                    >
						<DatePicker 
							hideYear
							hideMonth
							hideWeekDays
  							onlyDayPicker 
							highlightToday={false}
							weekStartDayIndex={5} 
                            ref={dayPickerRef} 
							editable={false}
							onOpen={() => setActive('1')}
							onClose={() => setActive(false)}
							render={<Icon style={{width: '25px', height: '25px', color: '#B2B1B3'}}/>}
  							calendar={gregorian}
  							locale={gregorian_en}
							onChange={handleChangeDay}
                            calendarPosition="bottom-left"
							style={{width: '140px', height: '38px'}}
						/>
						<span className='value'>
							{Translation.n(day)}
						</span>
					</div>
					
				</div>
				<div className='column-flex'>
					<span className='label'>
						Month
					</span>	
					<div 
                        className='row-flex second-input'
                        onClick={() => active !== '2' && monthPickerRef.current.openCalendar()}
                    >
						<DatePicker 
							hideYear
  							onlyMonthPicker 
							editable={false}
                            ref={monthPickerRef} 
							onOpen={() => setActive('2')}
							onClose={() => setActive(false)}
							render={<Icon style={{width: '25px', height: '25px', color: '#B2B1B3'}}/>}
  							calendar={gregorian}
  							locale={gregorian_en}
							onChange={handleChangeMonth}
  							calendarPosition="bottom-left"
							style={{width: '140px',  height: '38px'}}
						/>
						<span className='value'>
							{month}
						</span>
					</div>
				</div>
				<div className='column-flex'>
					<span className='label'>
						Year
					</span>	
					<div 
                        className='row-flex third-input'
                        onClick={() => active !== '3' && yearPickerRef.current.openCalendar()}
                    >
						<DatePicker 
							hideMonth
  							onlyYearPicker 
							editable={false}
  							calendar={gregorian}
  							locale={gregorian_en}
                            ref={yearPickerRef} 
							onOpen={() => setActive('3')}
							onClose={() => setActive(false)}
							render={<Icon style={{width: '25px', height: '25px', color: '#B2B1B3'}}/>}
							onChange={handleChangeYear}
  							calendarPosition="bottom-right"
							style={{width: '140px',  height: '38px'}}
						/>
						<span className='value'>
							{Translation.n(year)}
						</span>
					</div>
					
				</div>
			</div>
		</Wrapper>
	);
};

export default GregorianDatePicker;